import { z } from "zod";

const gouvGeometryDtoSchema = z.object({
  type: z.string(),
  coordinates: z.array(z.number()),
});

const gouvPropertiesDtoSchema = z.object({
  label: z.string(),
  score: z.number(),
  housenumber: z.string().optional(),
  id: z.string(),
  name: z.string(),
  postcode: z.string(),
  citycode: z.string(),
  x: z.number(),
  y: z.number(),
  city: z.string(),
  context: z.string(),
  type: z.string(),
  importance: z.number(),
  street: z.string().optional(),
});

export const gouvFeatureDtoSchema = z.object({
  type: z.string(),
  geometry: gouvGeometryDtoSchema,
  properties: gouvPropertiesDtoSchema,
});

export const gouvSearchResultDtoSchema = z.object({
  features: z.array(gouvFeatureDtoSchema),
});

export const postalAddressSchema = z.object({
  streetNumber: z.string().nullable(),
  street: z.string(),
  city: z.string(),
  postalCode: z.string(),
  complement: z.string().nullable(),
});

export type TGouvAddress = z.infer<typeof gouvPropertiesDtoSchema>;
export type TGouvAddressWithLatLng = TGouvAddress & {
  latitude: number;
  longitude: number;
};

export type TPostalAddress = z.infer<typeof postalAddressSchema>;

export type TGouvFeatureDto = z.infer<typeof gouvFeatureDtoSchema>;

export enum EGouvSearchAddressType {
  HOUSENUMBER = "housenumber",
  STREET = "street",
  LOCALITY = "locality",
  MUNICIPALITY = "municipality",
}

export const governmentAddressSuggestionSchema = z.object({
  id: z.string(),
  rawAddress: z.string(),
  streetNumber: z.string().nullable(),
  street: z.string(),
  complement: z.string().nullable(),
  postalCode: z.string(),
  city: z.string(),
  latitude: z.number(),
  longitude: z.number(),
  cityCode: z.string(),
  context: z.string(),
  score: z.number(),
  administrativeDivisions: z.array(z.string()),
  label: z.string(),
});

export type TGovernmentAddressSuggestion = z.infer<typeof governmentAddressSuggestionSchema>;
